import { Modal } from "@mantine/core";
import { useDoubleSidebar, useGlobal } from "@vojomo-core/shared";
import { Tooltip } from "antd";
import { TopicViewer } from "pages/TopicViewer/TopicViewer";
import { FaRegWindowMaximize } from "react-icons/fa";

export const TopicViewerModal = () => {
  const { isCollapsed } = useDoubleSidebar();
  const { modalTopicViewId, setModalTopicViewId } = useGlobal();

  return (
    <Modal.Root
      opened={!!modalTopicViewId}
      onClose={() => setModalTopicViewId(null)}
      centered
      style={{
        zIndex: 2,
        backgroundColor: "#f7f8fc",
        ...{ marginLeft: isCollapsed ? "0" : "130px" }
      }}
      size={isCollapsed ? "90%" : "75%"}
      styles={{
        body: {
          backgroundColor: "#f7f8fc"
        },
        header: {
          backgroundColor: "#f7f8fc"
        }
      }}
    >
      <Modal.Overlay />
      <Modal.Content>
        <Modal.Header>
          <Modal.CloseButton />
          <Tooltip title="Open Document in a New Tab">
            <FaRegWindowMaximize
              style={{
                fontWeight: 600,
                color: "var(--mantine-color-gray-7)",
                fontSize: "16px",
                cursor: "pointer",
                marginLeft: "5px"
              }}
              onClick={() => window.open(`/documents/docs/${modalTopicViewId}`)}
            />
          </Tooltip>
        </Modal.Header>
        <Modal.Body>
          <TopicViewer
            topicIdProps={modalTopicViewId}
            inModalView={true}
            readOnly={true}
          />
        </Modal.Body>
      </Modal.Content>
    </Modal.Root>
  );
};
